import { render, staticRenderFns } from "./clueDetails.vue?vue&type=template&id=16d3d0b4&scoped=true&"
import script from "./clueDetails.vue?vue&type=script&lang=js&"
export * from "./clueDetails.vue?vue&type=script&lang=js&"
import style0 from "./clueDetails.vue?vue&type=style&index=0&id=16d3d0b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d3d0b4",
  null
  
)

export default component.exports